import MonkeysForSalePage from './MonkeysForSalePage'
export default MonkeysForSalePage
